/**
 * `/site/policy` — **What you may say**: the conduct policy (FR-I4, T-4.10,
 * [ADR-0014](../../../../../docs/adr/0014-profession-policy-defaults-with-admin-override.md));
 * redrawn by Wave 14E (C13, spec §10.5 item 8, T-4.66).
 *
 * Five switches, defaulted per profession from the institute's own guidelines,
 * each overridable by the firm **with the source shown at the moment they
 * override it** — that last clause is ADR-0014 §2 and it is why the citation
 * travels in each switch's card rather than living in a help page a firm would
 * have to go and find.
 *
 * ## What each switch actually does — spec §9-18, now narrowed
 *
 * **Three of the five are enforced**, and all three the same way: at render,
 * by *omission*. `show_prices_public` leaves the fee out of the payload rather
 * than hiding it in the markup, so it is not in the page source either; since
 * FR-I14 (C5, ADR-0022 §6) `show_testimonials` and `show_client_names` do the
 * same to a whole section — `testimonial_strip`, `logo_strip`, `story_strip`.
 * Nothing is deleted: the firm's pages keep the sections and a visitor never
 * sees them.
 *
 * The other two remain advisory and for different reasons.
 * `show_comparative_claims` governs no section outright — it is why no section
 * carries a comparison field — and ProDesk cannot read a sentence and judge
 * whether it compares the firm to another. `allow_third_party_ads` has nothing
 * to hide because there is no ad slot and C5 added none; **that one switch is
 * all that is left of spec §9-18.**
 *
 * The screen **groups them by that difference** — *What your site will show*
 * and *What your institute's guidelines say* — and badges each card, because
 * telling a firm that a switch protects it when nothing reads it is a false
 * assurance about a regulator.
 *
 * ## Wave 14 — the one place the switches are drawn
 *
 * Since C13 (ADR-0032 §3) this is the only screen with the switches; *Settings
 * → Profession* links here. The switches, their one Save through the edit bar
 * and the leave guard are `components/ConductSwitches.tsx`; this is the page
 * around them.
 */

import { Link } from 'react-router'

import { ConductSwitches } from '../../components/ConductSwitches'
import { EditPage } from '../../components/edit'

export function SitePolicy() {
  return (
    <EditPage
      title="What you may say"
      back={{ to: '/site', label: 'Your website' }}
      description={
        <>
          If your profession has an institute, it has rules about how a practice may advertise
          itself. ProDesk starts from them, shows you the clause each comes from and lets you decide
          — the responsibility is yours. The defaults follow your profession, set in{' '}
          <Link to="/settings/profession" className="text-foreground font-medium underline">
            Settings → Profession
          </Link>
          .
        </>
      }
    >
      <ConductSwitches />
    </EditPage>
  )
}
